var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 307,
    width: 576,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 120c0-28.167-28.654-51-64-51-1 0-1.88.191-2.85.231 6.296 13.817 4.894 40.375-8.15 50.769s-35.37 2.746-52.71-2.271c0 .797-.29 1.498-.29 2.271 0 28.167 28.654 68 64 68s64-39.833 64-68zm220.52 21.828C518.29 57.235 410.93 0 288 0S57.68 57.275 3.48 141.836c-4.64 7.336-4.64 16 0 23.336C57.71 249.765 165.07 307 288 307s230.32-57.275 284.52-141.836c4.64-7.336 4.64-16 0-23.336zM288 29c70.692 0 128 49.473 128 110.5S358.692 250 288 250s-128-49.473-128-110.5c.077-61 57.34-110.433 128-110.5zm0 259c-107.36 0-205.46-48.95-256-127.743C60.424 115.705 117.1 66.539 173 44c-20.87 21.573-45 61.303-45 90.708C128 205.258 199.634 288 288 288s160-82.741 160-153.292c0-29.405-22.13-69.135-43-90.708 55.9 22.539 110.576 71.705 139 116.257C493.47 239.05 395.36 288 288 288z",
    fill: "#343a40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlack);
export default __webpack_public_path__ + "static/media/eye-black.f1d38bdc6ee6039cac26b01475dcfb2a.svg";
export { ForwardRef as ReactComponent };